require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/es7.symbol.observable.js
 ** module id = 998
 ** module chunks = 0
 **/